import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from "@angular/material/icon";
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-display-api-field-name',
    imports: [NgIf, TranslateDirective, TranslatePipe, MatIconModule],
    templateUrl: './display-api-field-name.component.html',
    styleUrls: ['./display-api-field-name.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayApiFieldNameComponent {
  @Input() name: string | undefined;
  #questionnaireStore = inject(QuestionnaireStore);
  apiExposureEnabled$ = toSignal(this.#questionnaireStore.apiExposureEnabled$);
}
